import { AntiAdBlockerToast } from '@teuteuf-games/anti-ad-blocker-toast';
import { useEffect, useState } from 'react';

const AntiAdBlockerComponent = ({
  adBlockerDetected,
}: {
  adBlockerDetected: boolean;
}) => {
  const [showAntiAdBlockerToast, setShowAntiAdBlockerToast] = useState(false);

  useEffect(() => {
    if (!adBlockerDetected) return;

    // if user has seen toast in the last 3 days, don't show toast
    const storedLastSeenAdBlockerToast =
      localStorage.getItem('ad-blocker-toast');
    const lastSeenToast = storedLastSeenAdBlockerToast
      ? JSON.parse(storedLastSeenAdBlockerToast)
      : null;
    if (lastSeenToast && Date.now() - lastSeenToast < 1000 * 60 * 60 * 24 * 3) {
      return;
    }

    setShowAntiAdBlockerToast(true);
    localStorage.setItem('ad-blocker-toast', JSON.stringify(Date.now()));
  }, [adBlockerDetected]);

  return (
    <div className="text-start">
      <AntiAdBlockerToast gameName="Flagle" show={showAntiAdBlockerToast} />
    </div>
  );
};

export default AntiAdBlockerComponent;
